import { useState, useEffect } from 'react';
import { settingsAPI } from '@/services/api';
import { toast } from 'react-toastify';
import BOLayout from '@/pages/back-office/BOLayout';
import SettingsTopBanner from '@/components/back-office/SettingsTopBanner';
import Button from '@/components/Button';

const ReferralSettings = () => {
  const [settings, setSettings] = useState({
    referral_reward_sponsor: 10,
    referral_reward_referred: 10,
    referral_verification_mode: 'OR',
    reorder_discount_days: 30,
    reorder_discount_amount: 10
  });
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    setIsLoading(true);
    try {
      const response = await settingsAPI.getReferralSettings();
      if (response.data) {
        setSettings(response.data);
      }
    } catch (error) {
      console.error('Error fetching referral settings:', error);
      toast.error('Erreur lors du chargement des paramètres');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await settingsAPI.updateReferralSettings(settings);
      toast.success('Paramètres sauvegardés avec succès');
    } catch (error) {
      console.error('Error saving referral settings:', error);
      toast.error('Erreur lors de la sauvegarde des paramètres');
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) {
    return (
      <BOLayout>
        <SettingsTopBanner />
        <div className="p-4">
          <p>Chargement...</p>
        </div>
      </BOLayout>
    );
  }

  return (
    <BOLayout>
      <SettingsTopBanner />
      <div className="p-4">
        <h1 className="text-2xl font-bold mb-6">Paramètres de Parrainage</h1>

        <div className="bg-white rounded-lg shadow-lg p-6 space-y-6">
          <div>
            <h2 className="text-lg font-semibold mb-4">Récompenses de Parrainage</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Récompense parrain (€)
                </label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  value={settings.referral_reward_sponsor}
                  onChange={(e) => setSettings({ ...settings, referral_reward_sponsor: parseFloat(e.target.value) || 0 })}
                  className="w-full rounded-md border border-gray-300 px-3 py-2"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Récompense filleul (€)
                </label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  value={settings.referral_reward_referred}
                  onChange={(e) => setSettings({ ...settings, referral_reward_referred: parseFloat(e.target.value) || 0 })}
                  className="w-full rounded-md border border-gray-300 px-3 py-2"
                />
              </div>
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Mode de vérification du parrain
              </label>
              <select
                value={settings.referral_verification_mode}
                onChange={(e) => setSettings({ ...settings, referral_verification_mode: e.target.value })}
                className="w-full rounded-md border border-gray-300 px-3 py-2"
              >
                <option value="OR">OR (Email OU téléphone)</option>
                <option value="AND">AND (Email ET téléphone)</option>
              </select>
            </div>
          </div>

          <div>
            <h2 className="text-lg font-semibold mb-4">Réduction</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Délai d'éligibilité (jours)
                </label>
                <input
                  type="number"
                  min="1"
                  value={settings.reorder_discount_days}
                  onChange={(e) => setSettings({ ...settings, reorder_discount_days: parseInt(e.target.value) || 30 })}
                  className="w-full rounded-md border border-gray-300 px-3 py-2"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Montant de la réduction (€)
                </label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  value={settings.reorder_discount_amount}
                  onChange={(e) => setSettings({ ...settings, reorder_discount_amount: parseFloat(e.target.value) || 0 })}
                  className="w-full rounded-md border border-gray-300 px-3 py-2"
                />
              </div>
            </div>
          </div>

          <div className="flex justify-end">
            <Button
              text="Sauvegarder"
              type="Button"
              action="button"
              handleClick={handleSave}
              disabled={!isSaving}
              extraClasses="px-6 py-2"
            />
          </div>
        </div>
      </div>
    </BOLayout>
  );
};

export default ReferralSettings;

